import React, { useRef, useState } from 'react';
import Papa from 'papaparse';
import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import { toast } from 'react-toastify';
import Button2 from 'devextreme-react/button';
import { DataGrid, Column, HeaderFilter, Search, ColumnFixing, Scrolling, FilterRow, FilterPanel, Selection, Toolbar, Item } from 'devextreme-react/data-grid';

import * as DynamicQueries from '../../services/DynamicQueries';

const Home = () => {
    const [age, setAge] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [gender, setGender] = useState('Masculino');
    const [reviewPage, setReviewPage] = useState('Ahorra Seguros');
    const [fileName, setFileName] = useState('');
    const [dataCsv, setDataCsv] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [processedData, setProcessedData] = useState([]);
    const [loading, setLoading] = useState(false);

    const dataGridRef = useRef(null);

    const getReviewData = () => {
        switch (reviewPage) {
            case 'Ahorra Seguros':
                setLoading(true);
                if (selectedRows.length === 0) {
                    setLoading(false);
                    toast.error('Debe seleccionar un vehículo del listado pre-cargado', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                } else {
                    DynamicQueries.dataWithParameters('/getDataPage', 'scraping', { age: age, gender: gender, postalCode: postalCode, phone: phone, email: email, name: name, selectedRows: selectedRows })
                        .then((resp) => {
                            console.log("🚀 ~ .then ~ resp.data:", resp.data)
                            if (resp.data.errors) {
                                setLoading(false);
                                resp.data.errors.forEach((errors) => {
                                    toast.error(errors.msg, {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                    });
                                })
                            } else if (resp.data.Operations) {
                                console.log("🚀 ~ .then ~ resp.data.Operations:", resp.data.Operations)
                                setProcessedData(resp.data.Operations);
                            }
                        })
                }
                break;

            default:
                break;
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFileName(file.name);
        if (file) {
            if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
                const reader = new FileReader();
                reader.onload = () => {
                    const csvText = reader.result;
                    parseCSV(csvText);
                };
                reader.readAsText(file);
            } else {
                console.log('Por favor selecciona un archivo CSV.');
            }
        }
    };

    const parseCSV = (csvText) => {
        Papa.parse(csvText, {
            header: true,
            complete: function (results) {
                // console.log('Array de datos:', results.data);
                const clearData = results.data.filter((x) => x.brand_name !== '');
                setDataCsv(clearData)
            }
        });
    };

    const onSelectionChanged = ({ selectedRowsData }) => {
        setSelectedRows(selectedRowsData);
    };

    const onExportXLS = async () => {
        const dataGrid = dataGridRef.current.instance;

        const dataSource = dataGrid.option('dataSource');

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('DataGrid Data');

        const headers = dataGrid.getVisibleColumns().map(column => column.caption);
        worksheet.addRow(headers);

        dataSource.forEach(item => {
            const rowData = dataGrid.getVisibleColumns().map(column => item[column.dataField] || '');
            worksheet.addRow(rowData);
        });

        const blob = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([blob], { type: 'application/octet-stream' }), 'dataDeAseguradoras.xlsx');

    };

    const reset = () => {
        setProcessedData([])
        setLoading(false);
    };

    return (
        <>
            <div>
                <div className="relative pb-6">
                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <h3 className="!text-2xl !ont-extrabold !tracking-tight !text-black md:!text-3xl lg:!text-4xl">Consultar Cotizador</h3>
                    </div>
                </div>
            </div>
            {processedData.length == 0 &&
                <>
                    <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                        <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-12">
                            <div className="shadow-lg sm:rounded-md sm:overflow-hidden">
                                <div className="bg-gray-50 py-6 px-4 space-y-6 sm:p-6">
                                    <div>
                                        <h3 className="!text-lg !leading-6 !font-medium !text-gray-900">Cotizadores</h3>
                                    </div>

                                    <div className="grid grid-cols-6 gap-6">
                                        <div className="col-span-6 sm:col-span-3">
                                            <label className="block text-sm font-medium text-gray-700">
                                                Seleccione cotizador {' '}
                                            </label>
                                            <select
                                                id="web-name"
                                                name="web-name"
                                                className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                value={reviewPage}
                                                onChange={(e) => {
                                                    setReviewPage(e.target.value);
                                                }}
                                            >
                                                <option value={'Ahorra Seguros'}>Ahorra Seguros</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                        <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-12">
                            <div className="shadow-lg sm:rounded-md sm:overflow-hidden">
                                <div className="bg-gray-50 py-6 px-4 space-y-6 sm:p-6">
                                    <div>
                                        <h3 className="!text-lg !leading-6 !font-medium !text-gray-900">Información Dinámica</h3>
                                    </div>

                                    <div className="grid grid-cols-6 gap-6">
                                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700">
                                                Edad* {' '}
                                            </label>
                                            <input
                                                type="number"
                                                name="age"
                                                id="age"
                                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                value={age}
                                                onChange={(e) => {
                                                    setAge(e.target.value)
                                                }}
                                            />
                                        </div>

                                        <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700">
                                                Genero* {' '}
                                            </label>
                                            <select
                                                id="gender"
                                                name="gender"
                                                className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                value={gender}
                                                onChange={(e) => {
                                                    setGender(e.target.value);
                                                }}
                                            >
                                                <option value={'Masculino'}>Masculino</option>
                                                <option value={'Femenino'}>Femenino</option>
                                            </select>
                                        </div>

                                        <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700">
                                                Código Postal* {' '}
                                            </label>
                                            <input
                                                type="number"
                                                name="postal-code"
                                                id="postal-code"
                                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                value={postalCode}
                                                onChange={(e) => {
                                                    setPostalCode(e.target.value)
                                                }}
                                            />
                                        </div>

                                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700">
                                                Nombre* {' '}
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                value={name}
                                                onChange={(e) => {
                                                    setName(e.target.value)
                                                }}
                                            />
                                        </div>

                                        <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700">
                                                Correo Electrónico* {' '}
                                            </label>
                                            <input
                                                type="text"
                                                name="email"
                                                id="email"
                                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                value={email}
                                                onChange={(e) => {
                                                    setEmail(e.target.value)
                                                }}
                                            />
                                        </div>

                                        <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                            <label className="block text-sm font-medium text-gray-700">
                                                Teléfono* {' '}
                                            </label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                id="phone"
                                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                value={phone}
                                                onChange={(e) => {
                                                    setPhone(e.target.value)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                        <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-12">
                            <div className="shadow-lg sm:rounded-md sm:overflow-hidden">
                                <div className="bg-gray-50 py-6 px-4 space-y-6 sm:p-6">
                                    <div>
                                        <h3 className="!text-lg !leading-6 !font-medium !text-gray-900">Adjuntar Archivo CSV</h3>
                                    </div>

                                    <div className="grid grid-cols-6 gap-6">
                                        <div className="col-span-6">
                                            <div className="mt-1 border-2 border-gray-300 border-dashed rounded-md px-6 pt-5 pb-6 flex justify-center">
                                                <div className="space-y-1 text-center">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="mx-auto h-12 w-12 text-gray-400"
                                                        stroke="currentColor"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        aria-hidden="true"
                                                    >
                                                        <path
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12-3-3m0 0-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                                                    </svg>

                                                    <div className="flex text-sm text-gray-600">
                                                        <label
                                                            className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                                                        >
                                                            <span>Cargar un archivo</span>
                                                            <input id="file-upload" name="file-upload" type="file" accept=".csv" className="sr-only" onChange={handleFileChange} />
                                                            <p className="text-xs text-gray-500">{fileName}</p>
                                                        </label>
                                                    </div>
                                                    {/* <p className="text-xs text-gray-500">CSV hasta 10MB</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                        <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-12">
                            <div className="shadow-lg sm:rounded-md sm:overflow-hidden">
                                <div className="bg-gray-50 py-6 px-4 space-y-6 sm:p-6">
                                    <div className="col-span-12 sm:col-span-3">
                                        <DataGrid
                                            // ref={dataGridRef}
                                            dataSource={dataCsv}
                                            allowColumnReordering={true}
                                            allowColumnResizing={true}
                                            columnResizingMode="widget"
                                            columnAutoWidth={true}
                                            showRowLines={false}
                                            showBorders={true}
                                            rowAlternationEnabled={true}
                                            displayMode='full'
                                            style={{ height: '75vh', width: '100%' }}
                                            onSelectionChanged={onSelectionChanged}
                                        >
                                            <Selection
                                                mode="multiple"
                                                selectAllMode='allPages'
                                                showCheckBoxesMode='always'
                                            />
                                            <FilterRow visible={true} />
                                            <FilterPanel visible={true} />
                                            <Scrolling rowRenderingMode='infinity'></Scrolling>
                                            <ColumnFixing enabled={true} />
                                            <HeaderFilter visible={true} />

                                            <Column dataField='version_code' caption='Código' >
                                                <HeaderFilter allowSelectAll={true}>
                                                    <Search enabled={true} />
                                                </HeaderFilter>
                                            </Column>

                                            <Column dataField='brand_name' caption='Marca' >
                                                <HeaderFilter allowSelectAll={true}>
                                                    <Search enabled={true} />
                                                </HeaderFilter>
                                            </Column>

                                            <Column dataField='model_name' caption='Modelo' >
                                                <HeaderFilter allowSelectAll={true}>
                                                    <Search enabled={true} />
                                                </HeaderFilter>
                                            </Column>

                                            <Column dataField='year_name' caption='Año'>
                                                <HeaderFilter allowSelectAll={true}>
                                                    <Search enabled={true} />
                                                </HeaderFilter>
                                            </Column>

                                            <Column dataField='version_name' caption='Versión' >
                                                <HeaderFilter allowSelectAll={true}>
                                                    <Search enabled={true} />
                                                </HeaderFilter>
                                            </Column>

                                            <Column dataField='segment' caption='Segmento' >
                                                <HeaderFilter allowSelectAll={true}>
                                                    <Search enabled={true} />
                                                </HeaderFilter>
                                            </Column>

                                            <Column dataField='list_price' caption='Precio de lista' >
                                                <HeaderFilter allowSelectAll={true}>
                                                    <Search enabled={true} />
                                                </HeaderFilter>
                                            </Column>

                                            <Column dataField='sale_price' caption='Precio de venta' >
                                                <HeaderFilter allowSelectAll={true}>
                                                    <Search enabled={true} />
                                                </HeaderFilter>
                                            </Column>
                                        </DataGrid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 flex justify-center">
                        <button
                            type="button"
                            className={`inline-flex items-center px-20 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#144DC9] hover:bg-${loading ? 'gray-400' : '[#144DC9]'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${loading ? 'gray-400' : '[#144DC9]'} disabled:opacity-50`}
                            onClick={getReviewData}
                            disabled={loading}
                        >
                            Iniciar Consulta
                            {loading && (
                                <div className="inline-block ml-5 h-4 w-4 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]">
                                    <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                                </div>
                            )}
                        </button>
                    </div>
                </>
            }

            {processedData.length > 0 &&
                <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                    <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-12">
                        <div className="shadow-lg sm:rounded-md sm:overflow-hidden">
                            <div className="bg-gray-50 py-6 px-4 space-y-6 sm:p-6">
                                <div className="col-span-12 sm:col-span-3">
                                    <DataGrid
                                        ref={dataGridRef}
                                        dataSource={processedData}
                                        allowColumnReordering={true}
                                        allowColumnResizing={true}
                                        columnResizingMode="widget"
                                        columnAutoWidth={true}
                                        showRowLines={false}
                                        showBorders={true}
                                        rowAlternationEnabled={true}
                                        displayMode='full'
                                        style={{ height: '75vh', width: '100%' }}
                                        onSelectionChanged={onSelectionChanged}
                                    >
                                        <FilterRow visible={true} />
                                        <FilterPanel visible={true} />
                                        <Scrolling rowRenderingMode='infinity'></Scrolling>
                                        <ColumnFixing enabled={true} />
                                        <HeaderFilter visible={true} />

                                        <Toolbar>
                                            <Item location="after">
                                                <Button2
                                                    icon='xlsfile'
                                                    onClick={onExportXLS}
                                                />
                                            </Item>
                                        </Toolbar>

                                        <Column dataField='carId' caption='ID' >
                                            <HeaderFilter allowSelectAll={true}>
                                                <Search enabled={true} />
                                            </HeaderFilter>
                                        </Column>

                                        <Column dataField='code' caption='Código de Operación' >
                                            <HeaderFilter allowSelectAll={true}>
                                                <Search enabled={true} />
                                            </HeaderFilter>
                                        </Column>

                                        <Column dataField='brand' caption='Marca' >
                                            <HeaderFilter allowSelectAll={true}>
                                                <Search enabled={true} />
                                            </HeaderFilter>
                                        </Column>

                                        <Column dataField='model' caption='Modelo' >
                                            <HeaderFilter allowSelectAll={true}>
                                                <Search enabled={true} />
                                            </HeaderFilter>
                                        </Column>

                                        <Column dataField='year' caption='Año'>
                                            <HeaderFilter allowSelectAll={true}>
                                                <Search enabled={true} />
                                            </HeaderFilter>
                                        </Column>

                                        <Column dataField='company' caption='Compañía de seguro' >
                                            <HeaderFilter allowSelectAll={true}>
                                                <Search enabled={true} />
                                            </HeaderFilter>
                                        </Column>

                                        <Column dataField='price' caption='Precio' >
                                            <HeaderFilter allowSelectAll={true}>
                                                <Search enabled={true} />
                                            </HeaderFilter>
                                        </Column>

                                        <Column dataField='date' caption='Fecha' >
                                            <HeaderFilter allowSelectAll={true}>
                                                <Search enabled={true} />
                                            </HeaderFilter>
                                        </Column>

                                        <Column dataField='title' caption='Cotizador' >
                                            <HeaderFilter allowSelectAll={true}>
                                                <Search enabled={true} />
                                            </HeaderFilter>
                                        </Column>
                                    </DataGrid>

                                    <div className="mt-6 flex justify-center">
                                        <button
                                            type="button"
                                            className="inline-flex items-center px-20 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#144DC9] hover:bg-[#144DC9] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#144DC9]"
                                            onClick={reset}
                                        >
                                            Generar otra consulta
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
};

export default Home;
